import {Component} from '@angular/core';


@Component({
  selector: 'app-open-map',
  imports: [],
  templateUrl: './open-map.component.html',
  styleUrl: './open-map.component.scss'
})
export class OpenMapComponent {

}
